import { useRef } from "react";
import { motion } from "framer-motion";
import whatsapp from "@/assets/landing/whasapp.webp";
import metrics from "@/assets/landing/metrics.webp";
import brain from "@/assets/icons/brain.webp";
import key_icon from "@/assets/icons/finanzas_icon.svg"
import MacbookFrame from "./ui/macbookFrame";
import DotGrid from "./ui/dotGrid";
import BrandMark from "./ui/brandMark";
import Reveal from "./ui/reveal";


const services = [
  {
    title: "Automatización de procesos",
    image: whatsapp,
    bullets: [
      "Asistente automatizado 24/7",
      "Ejecuta sin intervención humana",
      "Confirmación y recordatorios automáticos",
    ],
  },
  {
    title: "Operaciones Organizadas",
    image: key_icon,
    bullets: [
      "Portal que refleja citas en tiempo real",
      "Controla horarios y disponibilidad",
      "Organiza tu negocio desde un solo panel",
    ],
  },
  {
    title: "Insights y Métricas",
    image: metrics,
    bullets: [
      "Conoce tu rendimiento semanal y mensual",
      "Analiza servicios, horarios y clientes más valiosos",
      "Métricas que mejoran tu operación",
    ],
  },
  {
    title: "Experiencia digital Fluida",
    image: brain,
    bullets: [
      "Procesos modernos y profesionales",
      "Interacción intuitiva y sin fricción",
      "Simplicidad que hace que tus clientes regresen",
    ],
  },
];

export default function Services() {
  const trackRef = useRef<HTMLDivElement>(null);

  return (
    <section
      id="servicios"
      className="relative overflow-hidden bg-white py-20 md:py-28"
    >
      <DotGrid color="rgba(12,123,254,0.14)" size={30} />
      <div
        aria-hidden
        className="absolute top-10 left-1/2 hidden h-180 w-275 -translate-x-1/2 rounded-full border border-dashed border-nodric-blue/20 lg:block"
      />
      <BrandMark
        className="absolute -top-4 right-6 hidden h-200 w-200 bg-nodric-blue md:block"
        fadeFromBottom
      />

      <div className="relative z-10 mx-auto max-w-375 px-6 md:px-12">
        <Reveal>
          <h2 className="font-display max-w-[20ch] text-3xl leading-tight font-medium tracking-[0.06em] text-nodric-ink md:text-5xl">
            Conoce nuestros servicios principales
          </h2>
        </Reveal>

        <div className="mt-14 flex items-center gap-4">


          <div
            ref={trackRef}
            className="flex flex-1 snap-x snap-mandatory gap-6 overflow-x-auto scroll-smooth pb-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          >
            {services.map((service, index) => (
              <motion.article
                key={service.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.1,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="group w-70 shrink-0 snap-start md:w-[320px] xl:w-auto xl:min-w-0 xl:flex-1"
              >
                <h3 className="font-display mt-5 text-base tracking-[0.04em] text-nodric-ink">
                  {service.title}
                </h3>
                <div className="relative my-10 flex h-52 items-center justify-center overflow-hidden rounded-md bg-linear-to-br from-[#e9eaec] to-[#c9ccd1] transition-all duration-500 group-hover:from-nodric-blue group-hover:to-nodric-blue-deep md:h-60">

                  <div className="absolute inset-0 opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />

                  {service.image ? (
                    <img
                      src={service.image}
                      alt={service.title}
                      className="relative h-[100%] w-auto object-contain drop-shadow-2xl transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <MacbookFrame
                      alt={service.title}
                      className="relative w-[80%] transition-transform duration-500 group-hover:scale-105"
                      imageClassName="drop-shadow-2xl"
                    />
                  )}
                </div>



                <ul className="font-body space-y-1.5 text-[13px] leading-snug text-nodric-ink/70">
                  {service.bullets.map((bullet) => (
                    <li key={bullet} className="flex gap-2">
                      <span className="text-nodric-blue">•</span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </motion.article>
            ))}
          </div>


        </div>
      </div>
    </section>
  );
}
